import { apiWrapper, apiCancel } from '../../wrapper'

export const initial = 'mappingKelasPegawai'
const baseUrl = process.env.REACT_APP_SERVICE_CORE_URL
const appCode = process.env.REACT_APP_SERVICE_CORE_APPCODE
const outputType = 'json'

export const mappingKelasPegawaiCreate = 'Kepegawaian/MappingKelasPegawai/create/'
export const mappingKelasPegawaiList = 'Kepegawaian/MappingKelasPegawai/list/'
export const mappingKelasPegawaiDetail = 'Kepegawaian/MappingKelasPegawai/detail/'
export const mappingKelasPegawaiUpdate = 'Kepegawaian/MappingKelasPegawai/update/'
export const mappingKelasPegawaiInactive = 'Kepegawaian/MappingKelasPegawai/inactive/'
export const mappingKelasPegawaiActive = 'Kepegawaian/MappingKelasPegawai/active/'
export const mappingKelasPegawaiEmployeeList = 'Kepegawaian/MappingKelasPegawai/employeeList/'
export const mappingKelasPegawaiGradeList = 'Kepegawaian/MappingKelasPegawai/gradeList/'
// export const getPositionList = 'Master/List/position/'
export const getPositionList = 'Kepegawaian/MappingKelasPegawai/get_position/'


//export const cancelToken = () => apiCancel
export const cancelToken = () => {
    return apiCancel()
}
export const apiRequest = async (method, route, data = { params: null, body: null, cancelToken: null }, needToken=true) => {
    if(needToken) {
        const thisTime = (Math.floor(Date.now()/1000))
        const expire = localStorage.getItem(initial + 'accessExpired')
        if(expire < thisTime) {
           await apiWrapper(baseUrl, initial, appCode, outputType, 'post', 'auth/getAccessToken/', data)
           .then(result => {
                localStorage.setItem(initial + 'accessToken', result.response.access_token)
                return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)
            })
            .catch(result => {
                return Promise.reject('Tidak dapat mengambil accessToken');
            })
        } else {
            return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)        
        }
    }
    return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)
}